export const fastFilters = {
  is_complex: 'is_complex',
  is_building: 'is_building',
  is_apartment: 'is_apartment',
  is_pantry: 'is_pantry',
  is_office: 'is_office',
  is_parking_lot: 'is_parking_lot',
  is_parking_zone: 'is_parking_zone',
  is_parking_place: 'is_parking_place',
} as const;

export type FastFilters = (typeof fastFilters)[keyof typeof fastFilters];
